module.exports = __webpack_public_path__ + "img/loader-logo.9ce3f300.gif";